/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { TextField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedUrlModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related url"
    subtitle="Find an external page related to this article"
    okText="ADD URL"
    onSubmit={onSubmit}
  >
    <TextField label="URL title:" name="title" rules={[{ required: true, message: 'Title is required' }]} />
    <TextField
      label="URL:"
      name="url"
      style={NO_MARGIN_BOTTOM}
      rules={[
        { required: true, message: 'URL is required' },
        { type: 'url', message: "Doesn't look like a valid URL" },
      ]}
    />
  </RelatedContentModal>
);

const Item = (url) => <InfoItem description={<Link to={url.url}>{url.url}</Link>}>{url.title}</InfoItem>;

RelatedUrlModal.Item = Item;

export default RelatedUrlModal;
